// extracted by css-extract-rspack-plugin
export default {"cls1":"SourcePaperCard-cls1_iMz","cls2":"SourcePaperCard-cls2_VZC SourcePaperCard-cls1_iMz"};